// [PURPOSE]: Pure state-shape transforms for archive / unarchive / rename of savedCharacters.
// [WHY]: Extracted so production (App.jsx) and tests share one implementation — Rule 22.
// [INTEGRATION]: Consumed by App.jsx archiveCharacter / unarchiveCharacter / renameCharacter wrappers
//                that wire side effects (logActivity, systemBus, setSavedCharacters).

export function archiveById(characters, id) {
  if (!Array.isArray(characters)) return [];
  return characters.map(c => (c?.id === id ? { ...c, archived: true } : c));
}

export function unarchiveById(characters, id) {
  if (!Array.isArray(characters)) return [];
  return characters.map(c => (c?.id === id ? { ...c, archived: false } : c));
}

export function renameById(characters, id, newName) {
  if (!Array.isArray(characters)) return [];
  const trimmed = (newName || '').trim();
  if (!trimmed) return [...characters]; // empty/whitespace = no-op (preserves immutability)
  const stamp = new Date().toISOString();
  return characters.map(c => (c?.id === id ? { ...c, name: trimmed, lastModified: stamp } : c));
}
